import {
  CountryIso2,
  defaultCountries,
  FlagImage,
  parseCountry,
  usePhoneInput,
} from 'react-international-phone';
import {
  BaseTextFieldProps,
  InputAdornment,
  MenuItem,
  Select,
  TextField,
  Typography,
} from '@mui/material';
import { makeStyles } from '@mui/styles';

import FormInputErrorMessage from './form-input-error-message';

import 'react-international-phone/style.css';

const useStyles = makeStyles(() => ({
  input: {
    maxWidth: '100%',
    marginTop: '10px',
  },
  adornment: {
    marginRight: '2px',
    marginLeft: '-8px',
  },
  select: {
    width: 'max-content',
    '&.Mui-focused:has(div[aria-expanded="false"])': {
      fieldset: {
        display: 'block',
      },
    },
    '.MuiSelect-select': {
      padding: '8px',
      paddingRight: '24px !important',
    },
    '& fieldset': {
      border: 'none',
    },
    '& svg': {
      right: 0,
    },
  },
}));

const menuPropsStyle = {
  height: '300px',
  width: '360px',
  top: '10px',
  left: '-34px',
};

type Props = BaseTextFieldProps & {
  onChange: (phone: string) => void;
  value?: string | null;
  errorMessage?: string;
  label?: string;
};

const FormPhoneField = ({ value, onChange, label, errorMessage, ...other }: Props) => {
  const classes = useStyles();
  const { inputValue, handlePhoneValueChange, inputRef, country, setCountry } = usePhoneInput({
    defaultCountry: 'us',
    value: value || '',
    countries: defaultCountries,
    onChange: (data) => onChange(data.phone),
  });

  return (
    <div className={classes.input}>
      {label && <Typography variant="caption">{label}</Typography>}
      <TextField
        variant="outlined"
        color="primary"
        value={inputValue}
        onChange={handlePhoneValueChange}
        type="tel"
        inputRef={inputRef}
        fullWidth
        size="small"
        InputProps={{
          startAdornment: (
            <InputAdornment position="start" className={classes.adornment}>
              <Select
                className={classes.select}
                MenuProps={{
                  style: menuPropsStyle,
                  transformOrigin: {
                    vertical: 'top',
                    horizontal: 'left',
                  },
                }}
                value={country.iso2}
                onChange={(e) => setCountry(e.target.value as CountryIso2)}
                renderValue={(value) => <FlagImage iso2={value} style={{ display: 'flex' }} />}
              >
                {defaultCountries.map((c) => {
                  const country = parseCountry(c);
                  return (
                    <MenuItem key={country.iso2} value={country.iso2}>
                      <FlagImage iso2={country.iso2} style={{ marginRight: '8px' }} />
                      <Typography marginRight="8px">{country.name}</Typography>
                      <Typography color="gray">+{country.dialCode}</Typography>
                    </MenuItem>
                  );
                })}
              </Select>
            </InputAdornment>
          ),
        }}
        {...other}
      />
      {errorMessage && <FormInputErrorMessage error={errorMessage} />}
    </div>
  );
};

export default FormPhoneField;
